import { render } from "./DesignListModal.vue?vue&type=template&id=5d1c6960&ts=true"
import script from "./DesignListModal.vue?vue&type=script&lang=ts"
export * from "./DesignListModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__